/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider, List } from "@mantine/core";

export default function DefinitionsCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Interpretation and Definitions</Title>
      <Divider my="md" />
      <Title order={4}>Interpretation</Title>
      <Text>
        Words with initial capital letters have meanings defined under the
        following conditions. The following definitions shall have the same
        meaning regardless of whether they appear in singular or plural.
      </Text>

      <Title order={4} mt="md">
        Definitions
      </Title>
      <List spacing="xs" mt="sm">
        <List.Item>
          <strong>Account</strong> means a unique account created for You to
          access our Service or parts of our Service.
        </List.Item>
        <List.Item>
          <strong>Affiliate</strong> —means an entity that controls, is
          controlled by or is under common control with a party, where
          &quot;control&quot; means ownership of 50% or more of the shares,
          equity interest or other securities entitled to vote for election of
          directors or other managing authority.
        </List.Item>
        <List.Item>
          <strong>Application</strong> — Refers to TaskForge, the software
          program provided by the Company.
        </List.Item>
        <List.Item>
          <strong>Company</strong> (referred to as either &quot;the
          Company&quot;, &quot;We&quot;, &quot;Us&quot; or &quot;Our&quot; in
          this Agreement) refers to TaskForge.
        </List.Item>
        <List.Item>
          <strong>Country</strong> — Saskatchewan, Canada.
        </List.Item>
        <List.Item>
          <strong>Device</strong> means any device that can access the Service
          such as a computer, a cellphone or a digital tablet.
        </List.Item>
        <List.Item>
          <strong>Personal Data</strong> — Information related to an
          identifiable individual.
        </List.Item>
        <List.Item>
          <strong>Service</strong> — Refers to the Application.
        </List.Item>
        <List.Item>
          <strong>Service Provider</strong> — Third-party company or individual
          processing data on behalf of the Company.
        </List.Item>
        <List.Item>
          <strong>Usage Data</strong> — Data collected automatically.
        </List.Item>
        <List.Item>
          <strong>You</strong> — The individual using the Service.
        </List.Item>
      </List>
    </Card>
  );
}
